<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="mail-monitors-page mb-4">

    <section class="d-flex full-width justify-content-end">
      <b-button @click="$bvModal.show('modal-add-monitor')" class="btn-success">Add Mail Monitor</b-button>
    </section>

    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            cy="prisoner-number-input"
            @keyup.enter="searchMailMonitors()"
            v-model="filters.prisoner_number"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="searchMailMonitors()" v-model="filters.sort" class="mb-1">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3 align-items-center d-flex" style="margin-top: 5px">
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchMailMonitors()">Search</b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="monitors"
          :fields="headers"
          :current-page="currentPage"
          :per-page="null"
        >
          <template #cell(prisoner_number)="data">
            {{data.item.prisoner_number || '-'}}
          </template>

          <template #cell(reason)="data">
            {{data.item.reason || '-'}}
          </template>

          <template #cell(auto_assign_clinician_user_id)="data">
            {{getClinicianNameById(data.item.auto_assign_clinician_user_id) || '-'}}
          </template>

          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>
          <template #cell(created_at)="data">
            {{data.item.created_at | formatDateTime}}
          </template>
          <template #cell(actions)="data">
            <b-btn variant="danger" @click="showMailMonitorModal(data.item, 'modal-delete-monitor')">
              Delete
            </b-btn>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination @change="getMailMonitors()" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No records</p>
        </b-row>
      </section>
    </b-card>

    <b-modal id="modal-add-monitor" title="Add new mail monitor" hide-footer>
      <add-monitor @refresh="getMailMonitors()" @close="closeModals()"></add-monitor>
    </b-modal>

    <b-modal id="modal-delete-monitor" title="Delete Mail Monitor" hide-footer>
      <delete-modal v-if="selectedMonitor" @close="closeModals()" @delete="deleteMonitor(selectedMonitor)"
                    :subtitle="selectedMonitor.prisoner_number"
                    title="Are you sure you wish to delete monitor for"></delete-modal>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex';
import AddMonitor from '@/views/mailMonitors/sections/AddMonitor.vue';
import MailMonitorService from '@/services/MailMonitorService';
import HelperService from '../../services/HelperService';
import DeleteModal from '../../components/modals/DeleteModal.vue';

export default {
  name: 'MailMonitorSearch',
  components: {
    DeleteModal,
    AddMonitor,
  },
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      selectedMonitor: null,
      headers: [
        { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
        { label: 'Reason', key: 'reason' },
        { label: 'Assigned To', key: 'auto_assign_clinician_user_id' },
        { label: 'Created', key: 'created_at' },
        { label: 'Updated', key: 'updated_at' },
        { label: '', key: 'actions' },
      ],
      monitors: [],
      currentPage: 1,
      totalRows: 10,
      filters: {
        prisoner_number: '',
        skip: 1,
        sort: '-updated_at',
        limit: 10,
      },
    };
  },
  computed: {
    ...mapState({
      clinicians: state => state.postCard.clinicians,
    }),
  },
  watch: {
    currentPage() {
      this.getMailMonitors();
    },
    $route() {
      this.setUp();
    },
  },
  mounted() {
    this.setUp();
  },
  methods: {
    setUp() {
      this.getMailMonitors();

      if (!this.clinicians.length) {
        this.$store.dispatch('postCard/refreshClinicians');
      }
    },
    searchMailMonitors() {
      this.currentPage = 1;

      this.getMailMonitors();
    },
    closeModals() {
      this.$bvModal.hide('modal-add-monitor');
      this.$bvModal.hide('modal-delete-monitor');
    },
    getMailMonitors() {
      this.filters.skip = (this.currentPage - 1) * this.filters.limit;
      this.closeModals();

      MailMonitorService.getAllMailMonitors(this.filters).then(res => {
        this.loading = false;
        this.monitors = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting mail monitors ', err);
        this.$toast.error('Could not get mail monitors, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    clearFilters() {
      this.filters = {
        prisonNumber: '',
        skip: 1,
      };

      this.searchMailMonitors();
    },
    setSelectedMonitor(monitor) {
      this.selectedMonitor = monitor;
    },
    showMailMonitorModal(monitor, modalName) {
      this.setSelectedMonitor(monitor);
      this.$bvModal.show(modalName);
    },
    deleteMonitor(monitor) {
      // eslint-disable-next-line no-underscore-dangle
      MailMonitorService.deleteMonitor(monitor._id).then(() => {
        this.$toast.success(`Deleted monitor for ${monitor.prisoner_number} Successfully`, {
          toastClassName: ['toast-std', 'success-toast'],
        });

        this.getMailMonitors();
      }).catch(err => {
        console.log('error deleting monitor', err);
        this.$toast.error('Could not delete monitor, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    getClinicianNameById(id) {
      const clinician = this.clinicians.find(item => item.user_id === id);

      return clinician ? clinician.name : '';
    },
  },
};
</script>
